package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.PortalGetFootStyle
import com.anjuros.website.redesign.styles.PortalGetStepsStyle
import com.anjuros.website.redesign.styles.PortalStepLabelStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val Steps = listOf(
    RdText.PORTAL_GET1_TITLE to RdText.PORTAL_GET1_TEXT,
    RdText.PORTAL_GET2_TITLE to RdText.PORTAL_GET2_TEXT,
    RdText.PORTAL_GET3_TITLE to RdText.PORTAL_GET3_TEXT,
)

/** The 2 free months of Full Service, step by step, on the plain page background so it stands apart from the FAQ band below. */
@Composable
fun PortalGetItSection() {
    RdSection(id = "get", labelledBy = "get-h") {
        RdSectionHead(RdText.PORTAL_GET_EYEBROW, "get-h", RdText.PORTAL_GET_TITLE, RdText.PORTAL_GET_LEDE)
        Ol(PortalGetStepsStyle.toModifier().toAttrs()) {
            Steps.forEachIndexed { index, (title, text) ->
                Li {
                    Span(PortalStepLabelStyle.toModifier().toAttrs()) {
                        Text(LocalText(RdText.PORTAL_STEP_LABEL).replace("%d", (index + 1).toString()))
                    }
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
        }
        Div(PortalGetFootStyle.toModifier().toAttrs()) {
            P { Text(LocalText(RdText.PORTAL_GET_FOOT)) }
            RdGhostButton(RdRoute.PRICING, RdText.PORTAL_GET_COMPARE, withArrow = true)
        }
    }
}
